import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Table,
  TableRow,
  TableCell,
  Grid,
  TableHead,
  TableBody,
  CircularProgress,
  Avatar,
  IconButton,
  Button,
} from '@material-ui/core';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
// import SpeakerNotes from '@material-ui/icons/SpeakerNotes';
import { withStyles } from '@material-ui/core/styles';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { useSnackbar } from 'notistack';
import {
  fetchPatientTrackerInfo,
  // createConsultNote,
  deleteTrackPatient,
} from '../services/api';
// import ConsultNoteEditModal from '../components/ConsultNoteEditModal';
import PatientTrackingModal from '../scenes/ProviderAdminPatients/components/PatientTracking';
import PatientCreateTrackModal from '../scenes/ProviderAdminPatients/components/PatientCreateTrackModal';
import RemovePatientTrackModal from './RemovePatientTrackModal';
// import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// import AttachmentIcon from '@material-ui/icons/Attachment';
// import ApptAttachmentModal from './ApptAttachmentModal';

function PatientTracker(props) {
  const {
    patientId,
    patientInfo,
    classes: { loading, customSpacing, drawerIcon },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [trackInfo, setTrackInfo] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [attachment, setAttachment] = useState(null);
  const [openPatientTrackEditModal, setOpenPatientTrackEditModal] = useState(
    false
  );
  const [
    openPatientTrackCreateModal,
    setOpenPatientTrackCreateModal,
  ] = useState(false);
  const [
    openRemovePatientTrackModal,
    setOpenRemovePatientTrackModal,
  ] = useState(false);
  const [openTrackingReports, setOpenTrackingReports] = useState(false);
  //   const [openConsultNotesModal, setOpenConsultNotesModal] = useState(false);
  //   const [patientUnderEdit, setPatientUnderEdit] = useState({});
  const [patientTrackEdit, setPatientTrackEdit] = useState({});
  const [patientTrackId, setPatientTrackId] = useState('');

  useEffect(() => {
    (async () => {
      try {
        fetchPatientTrackInfo();
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's appointments");
      }
      setIsLoading(false);
    })();
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       fetchPatientTrackInfo();
  //     } catch (err) {
  //       enqueueSnackbar("Unable to fetch patient's appointments");
  //     }
  //     setIsLoading(true);
  //   })();
  // }, [pageIndex]);

  const fetchPatientTrackInfo = async () => {
    const trackInfo = await fetchPatientTrackerInfo(
      patientId
      //   pageLimit,
      //   pageIndex * 10
    );
    setTrackInfo(trackInfo);
    setIsLoading(false);
  };

  const onViewPatientTrack = item => {
    setPatientTrackEdit(item);
    setOpenPatientTrackEditModal(true);
  };

  //   const onSendConsultNote = patient => {
  //     patient.name = patient.firstName + ' ' + patient.lastName;
  //     setPatientUnderEdit(patient);
  //     setOpenConsultNotesModal(true);
  //   };

  //   const sendConsultNote = async noteParams => {
  //     try {
  //       await createConsultNote(noteParams);
  //       onDialogClose();
  //       enqueueSnackbar('Successfully sent note!');
  //     } catch (err) {
  //       enqueueSnackbar('Unable to send note. Please try again.');
  //     }
  //   };

  //   const onDialogClose = () => {
  //     setPatientUnderEdit({});
  //     setOpenConsultNotesModal(false);
  //   };

  const removeTrackPatient = id => {
    setOpenRemovePatientTrackModal(true);
    setPatientTrackId(id);
  };

  const openPatientTrack = () => {
    setPatientTrackEdit(patientInfo);
    setOpenPatientTrackCreateModal(true);
  };

  const onCloseModal = () => {
    setPatientTrackEdit({});
    setOpenPatientTrackEditModal(false);
    setOpenTrackingReports(false);
  };

  const onCloseCreateModal = () => {
    setOpenPatientTrackCreateModal(false);
    setOpenTrackingReports(false);

    // calling fetch Api for update list
    fetchPatientTrackInfo();
  };

  const onCloseRemovePatientModal = () => {
    setOpenRemovePatientTrackModal(false);
  };

  const onRemoveTrackSubmit = async () => {
    try {
      await deleteTrackPatient(patientTrackId);
      onCloseRemovePatientModal();
      fetchPatientTrackInfo();
      enqueueSnackbar('Removed from track!', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    } catch (err) {
      enqueueSnackbar('Unable to remove patient. Please try again.', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={props.classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      {trackInfo && trackInfo.length > 0 ? (
        <Button
          variant="contained"
          color="primary"
          disabled={true}
          //onClick={openPatientTrack}
          className="appointBtn"
        >
          Track Patient
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          onClick={() => openPatientTrack()}
          className="appointBtn"
        >
          Track Patient
        </Button>
      )}

      <Table id="table-to-xls" className="patientTrack">
        <TableHead>
          <TableRow>
            <TableCell>Patient</TableCell>
            <TableCell>Type of Reason</TableCell>
            <TableCell>Track Status</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            {/* <TableCell>Message a Doc</TableCell> */}
            <TableCell>View</TableCell>
            <TableCell>Remove</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {trackInfo.length > 0 &&
            trackInfo.map(item => (
              <TableRow key={item.id}>
                <TableCell width="300">
                  <Grid container alignItems="center" className="profilePic">
                    {/* <Avatar
                      providerId={item.patient.id}.
                      customStyles={{
                        height: '35px',
                        width: '35px',
                      }}
                    /> */}
                    <Grid item xs={6}>
                      {item.patient.firstName} &nbsp; {item.patient.lastName}
                    </Grid>
                  </Grid>
                </TableCell>
                <TableCell width="250">{item.typeOfTrack}</TableCell>
                <TableCell width="250">
                  {item.trackStatus ? 'Active' : '-'}
                </TableCell>
                <TableCell width="200">
                  {moment(item.startDate).format('MM/DD/YYYY hh:mma')}
                </TableCell>
                <TableCell width="200">
                  {moment(item.endDate).format('MM/DD/YYYY hh:mma')}
                </TableCell>

                {/* <TableCell>
                  <IconButton
                    title="Doc to Doc Message"
                    onClick={() => onSendConsultNote(item.patient)}
                  >
                    <SpeakerNotes className={drawerIcon} />
                  </IconButton>
                </TableCell> */}
                <TableCell>
                  <IconButton
                    title="view patient tracking details"
                    onClick={() => onViewPatientTrack(item)}
                  >
                    <RemoveRedEyeIcon />
                  </IconButton>
                </TableCell>

                <TableCell>
                  <IconButton
                    title="Delete Track Patient"
                    onClick={() => removeTrackPatient(item.id)}
                  >
                    <DeleteForeverOutlinedIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      {/* <div className={props.classes.pageTurners}>
        <IconButton disabled={pageIndex === 0}>
          <ArrowBackIosIcon
            style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageBack}
          />
        </IconButton>
        <IconButton>
          <ArrowForwardIosIcon
            style={{ opacity: appts.length < pageLimit ? '0.5' : '1.0' }}
            color="primary"
            variant="contained"
            onClick={onPageForward}
          />
        </IconButton>
      </div> */}
      {openPatientTrackEditModal && (
        <PatientTrackingModal
          open={openPatientTrackEditModal}
          note={patientTrackEdit}
          closeDialog={onCloseModal}
          trackingEdit={true}
        />
      )}
      {openRemovePatientTrackModal && (
        <RemovePatientTrackModal
          open={openRemovePatientTrackModal}
          onClose={onCloseRemovePatientModal}
          save={onRemoveTrackSubmit}
        />
      )}
      {openPatientTrackCreateModal && (
        <PatientCreateTrackModal
          open={openPatientTrackCreateModal}
          patientId={patientId}
          note={patientTrackEdit}
          closeDialog={onCloseCreateModal}
        />
      )}
      {/* {openConsultNotesModal && (
        <ConsultNoteEditModal
          patient={patientUnderEdit}
          open={openConsultNotesModal}
          save={sendConsultNote}
          onClose={onDialogClose}
        />
      )} */}
    </>
  );
}

PatientTracker.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  customSpacing: {
    marginLeft: '21px',
    display: 'block',
  },
});

export default withStyles(styles)(PatientTracker);
